export const PROGRAM = [
    {label: "Postgraduate", value: "postgraduate"},
    {label: "Undergraduate", value: "undergraduate"}
];

export const ADMISSION = [
    {label: "Regular Admission", value: "regular"},
    {label: "Early Admission", value: "early"}
];

export const RELATION = [
    {label: "Mother", value: "mother"},
    {label: "Guardian", value: "guardian"},
    {label: "Brother", value: "brother"},
    {label: "Sister", value: "sister"},
    {label: "Teacher/Professor", value: "teacher"},
    {label: "Friend", value: "friend"},
    {label: "Relative", value: "relative"},
    {label: "Spouse", value: "spouse"},
]

export const KNOWABOUT = [
        {label: "Magazines", value: "magazines"},
        {label: "Information session/Public Lecture", value: "informarion"},
        {label: "Azim Premji Foundation/University", value: "azfu"},
        {label: "Azim Premji University Students", value: "azus"},
        {label: "Google Search", value: "google"},
        {label: "Newspaper Advertisement", value: "newspaper"},
        {label: "Social Media", value: "socialMedia"},
        {label: "Friend/Family/Colleague", value: "friend"},
        {label: "Through my School/College/Professor/Teachers", value: "school"},
        {label: "Alumini Azim Premji University", value: "alumini"},
        {label: "Foundation Members Information Sessions at your School", value: "foundation"},
        {label: "College Family", value: "college"},
        {label: "Friends School Teachers", value: "teacher"},
        {label: "College Professors", value: "professor"},
        {label: "Education Counsellors Google Search, Social Media Newspaper", value: "education"},
        {label: "Partner Organization", value: "partner"},
]

export const NATIONALITY = [
    {label:"Indian", value: "indian"},
    {label:"Others", value: "others"}
]
export const DOMICILE = [
    {label:"Karnataka", value: "karnataka"},
    {label:"Madhya Pradesh", value: "madhya Pradesh"},
    {label:"Others", value: "others"}
]
export const GENDER = [
    {label:"Female", value: "female"},
    {label:"Male", value: "male"},
    {label:"Others", value: "other"}
]
export const LANGUAGE = [
    {label:"Bengali", value: "bengali"},
    {label:"Bhojpuri", value: "bhojpuri"},
    {label:"Gujrati", value: "gujrati"},
    {label:"Hindi", value: "hindi"},
    {label:"Kannada", value: "kannada"},
    {label:"Malyalam", value: "malyalam"},
    {label:"Marathi", value: "marathi"},
    {label:"Nepali", value: "nepali"},
    {label:"Punjabi", value: "punjabi"},
    {label:"Sindhi", value: "sindhi"},
    {label:"Tamil", value: "tamil"},
    {label:"Telugu", value: "telugu"},
]
export const APPLYINGPROGRAM = [
    {label:"BSc BEd(Biology and Education)", value: "BSc BEd(Biology and Education)"},
    {label:"BSc BEd(Mathematics and Education)", value: "BSc BEd(Mathematics and Education)"},
    {label:"No Second Preference", value: ""},
]
export const PREFERPROGRAM = [
    {label:"", value: ""}
]
export const CAMPUS = [
    {label:"Banglore", value: "banglore"},
    {label:"Bhopal", value: "bhopal"}
]
export const TESTCENTER = [
    {label:"Bhubaneshwar", value: "bhubaneshwar"},
    {label:"Calicut", value: "calicut"},
    {label:"Chandigarh", value: "chandigarh"},
    {label:"Delhi", value: "delhi"},
    {label:"Delhi New Venue", value: "delhinew"},
    {label:"Delhi-PG", value: "delhipg"},
    {label:"Dharwad", value: "dharwad"},
    {label:"Indore", value: "indore"},
    {label:"Lucknow", value: "lucknow"},
    {label:"Madurai", value: "madurai"},
    {label:"Manglore", value: "manglore"},
    {label:"Nagpur", value: "nagpur"},
    {label:"Patna", value: "patna"},
    {label:"Pune_Test Venue", value: "punevenue"},
    {label:"Ranchi", value: "ranchi"},
    {label:"Siliguri", value: "siliguri"},
    {label:"Sirsi", value: "sirsi"},
    {label:"Thiruvananthapuram", value: "thiruvananthapuram"},
    {label:"varanasi", value: "varanasi"},
]
export const INTERVIEWCENTER = [
    {label:"Ahmedabad", value: "ahmedabad"},
    {label:"Bengaluru(In person)", value: "bengaluru"},
    {label:"Delhi", value: "delhi"},
    {label:"Offline", value: "offline"},
    {label:"Online", value: "online"},
    {label:"Online", value: "online"},
    {label:"Pune_Interview Venue", value: "puneinterview"},
    {label:"Raipur", value: "raipur"},
]

export const HAVEYOUTAKENMOREYEARS = [
    {Id: true, value: "Yes"},
    {Id: false, value: "No"},
]

export const HAVEPGEDUCATION = [
    {Id: "Yes", value: "Yes"},
    {Id: "No", value: "No"},
]
export const FAMINCOME = [
    { Id: "Above 15 Lakhs", value: "Above 15 Lakhs" },
    { Id: "14.01 Lakhs to 15 Lakhs", value: "14.01 Lakhs to 15 Lakhs" },
    { Id: "13.01 Lakhs to 14 Lakhs", value: "13.01 Lakhs to 14 Lakhs" },
    { Id: "12.01 Lakhs to 13 Lakhs", value: "12.01 Lakhs to 13 Lakhs" },
    { Id: "11.01 Lakhs to 12 Lakhs", value: "11.01 Lakhs to 12 Lakhs" },
    { Id: "10.01 Lakhs to 11 Lakhs", value: "10.01 Lakhs to 11 Lakhs" },
    { Id: "9.01 Lakhs to 10 Lakhs", value: "9.01 Lakhs to 10 Lakhs" },
    { Id: "8.01 Lakhs to 9 Lakhs", value: "8.01 Lakhs to 9 Lakhs" },
    { Id: "7.01 Lakhs to 8 Lakhs", value: "7.01 Lakhs to 8 Lakhs" },
    { Id: "6.01 Lakhs to 7 Lakhs", value: "6.01 Lakhs to 7 Lakhs" },
    { Id: "5.01 Lakhs to 6 Lakhs", value: "5.01 Lakhs to 6 Lakhs" },
    { Id: "4.01 Lakhs to 5 Lakhs", value: "4.01 Lakhs to 5 Lakhs" },
    { Id: "3.01 Lakhs to 4 Lakhs", value: "3.01 Lakhs to 4 Lakhs" },
    { Id: "2.01 Lakhs to 3 Lakhs", value: "2.01 Lakhs to 3 Lakhs" },
    { Id: "Below 2 Lakhs", value: "Below 2 Lakhs" }
];
export const restrictedPrograms = [
    "ITEP BSc BEd in Biology (Secondary Stage)",
    "ITEP BSc BEd in Mathematics (Secondary Stage)",
    "BA Honours (Economics)",
    "BA Honours (English)",
    "BA Honours (History)",
    "BA Honours (Philosophy)",
    "BA Honours (Philosophy, Politics and Economics)",
    "BA Honours (Social Science)",
    "BSc Honours (Biology)",
    "BSc Honours (Chemistry)",
    "BSc Honours (Environmental Science and Sustainability)",
    "BSc Honours (Information Sciences)",
    "BSc Honours (Mathematics)",
    "BSc Honours (Physics)",
    "BSc Honours (Psychology)",
  ];
export const programMsg = {
    "ITEP BSc BEd in Biology (Secondary Stage)": "ITEP_BSc_BEd_in_Biology_Secondary_Stage",
    "ITEP BSc BEd in Mathematics (Secondary Stage)": "ITEP_BSc_BEd_in_Mathematics_Secondary_Stage",
    "BA Honours (Economics)": "APU_SAT_BA_Economics",
    "BA Honours (English)": "APU_SAT_BA_English",
    "BA Honours (History)": "APU_SAT_BA_History",
    "BA Honours (Philosophy)": "APU_SAT_BA_Philosophy",
    "BA Honours (Philosophy, Politics and Economics)": "BA_Honours_Philosophy_Politics_and_Economics",
    "BA Honours (Social Science)": "APU_SAT_BA_Social_Science",
    "BSc Honours (Biology)": "APU_SAT_BSc_Biology",
    "BSc Honours (Chemistry)": "APU_SAT_BSc_Chemistry",
    "BSc Honours (Environmental Science and Sustainability)": "APU_SAT_BSc_Environmental_Science_and_Sustainability",
    "BSc Honours (Information Sciences)": "APU_SAT_Information_Sciences",
    "BSc Honours (Mathematics)": "APU_SAT_BSc_Mathematics",
    "BSc Honours (Physics)": "APU_SAT_BSc_Physics",
    "BSc Honours (Psychology)": "APU_SAT_BSc_Psychology",
  };

  export const mbaProgram = [
    "Master of Business Administration (Development Management)"
  ]

  export const restrictedExternalProgram = {
    "Master of Business Administration (Development Management)": "MBA_External",
  }
  export const restrictedmbaProgram = {
    "Master of Business Administration (Development Management)": "MBA"
  }
 export const restrictedMPHProgram = {
    "Master of Public Health": "MPH_Notes"
  }



